import React from 'react';
import './LiquidityEdgeFooter.scss';

const LiquidityEdgeFooter = () => (
    <React.Fragment>
        <footer className="lefooter">
            <div className="container lefooter__container">

                <h2 className="lefooter__title">Contact Us</h2>

                <div className="lefooter__row">

                    <div className="lefooterColumn">

                        <div className="lefooterColumn__row">
                            <h3 className="lefooterColumn__title">
                                New York
                            </h3>
                            <ul className="lefooterColumn__info">
                                <li className="lefooterColumn__item">
                                    <a href="tel:16466307420">Tel: +1 646 630 7420</a>
                                </li>
                                <li className="lefooterColumn__item">
                                    <a href="mailto:contact@liquidityedge.net">contact@liquidityedge.net</a>
                                </li>
                            </ul>
                        </div>

                        <div className="lefooterColumn__row">
                            <h3 className="lefooterColumn__title">
                                London
                            </h3>
                            <ul className="lefooterColumn__info">
                                <li className="lefooterColumn__item">
                                    <a href="tel:442071131526">Tel: +44 207 113 1526</a>
                                </li>
                                <li className="lefooterColumn__item">
                                    <a href="mailto:tcook@liquidityedge.net">tcook@liquidityedge.net</a>
                                </li>
                            </ul>
                        </div>

                    </div>

                    <div className="lefooterColumn">
                        <div className="lefooterColumn__row">
                            <h3 className="lefooterColumn__title">
                                Media Enquiries
                            </h3>
                            <ul className="lefooterColumn__info">
                                <li className="lefooterColumn__item">
                                    <a href="tel:12128136355">Tel: +1 212 813 6355</a>
                                </li>
                            </ul>
                        </div>

                        <div className="lefooterColumn__row lefooterColumn__social">
                            <a href="http://www.twitter.com/liquidityedge" target="_blank" rel="noopener noreferrer">
                                <span className="fa-circle-outer">
                                    <span className="fab fa-x-twitter"/>
                                </span>
                            </a>

                            <a href="https://www.linkedin.com/company/liquidity-edge" target="_blank" rel="noopener noreferrer">
                                <span className="fa-circle-outer">
                                    <span className="fab fa-linkedin-in"/>
                                </span>
                            </a>
                        </div>
                    </div>

                    <div className="lefooterColumn lefooterColumn--hours">

                        <h3 className="lefooterColumn__title">
                            Hours of Operation
                        </h3>

                        <div className="lefooterHours">

                            <div className="lefooterHours__column lefooterHours__column--days">
                                <h4 className="lefooterHours__title">
                                    Trading Day
                                </h4>
                                <ul className="lefooterColumn__info">
                                    <li className="lefooterColumn__item">Monday</li>
                                    <li className="lefooterColumn__item">Tuesday</li>
                                    <li className="lefooterColumn__item">Wednesday</li>
                                    <li className="lefooterColumn__item">Thursday</li>
                                    <li className="lefooterColumn__item">Friday</li>
                                </ul>
                            </div>

                            <div className="lefooterHours__column lefooterHours__column--hours">
                                <h4 className="lefooterHours__title">
                                    Hours (ET)
                                </h4>
                                <ul className="lefooterColumn__info">
                                    <li className="lefooterColumn__item">Sunday 6:30 pm - Monday 5:30 pm</li>
                                    <li className="lefooterColumn__item">Monday 6:30 pm - Tuesday 5:30 pm</li>
                                    <li className="lefooterColumn__item">Tuesday 6:30 pm - Wednesday 5:30 pm</li>
                                    <li className="lefooterColumn__item">Wednesday 6:30 pm - Thursday 5:30 pm</li>
                                    <li className="lefooterColumn__item">Thursday 6:30 pm - Friday 5:00 pm</li>
                                </ul>
                                <p className="lefooterHours__notice">
                                    We follow the <a href="https://www.sifma.org/resources/general/holiday-schedule/" target="_blank" rel="noopener noreferrer">SIFMA Holiday Schedule</a>
                                </p>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </footer>
    </React.Fragment>
);

export default LiquidityEdgeFooter;



// WEBPACK FOOTER //
// ./frontend/components/Footer/LiquidityEdgeFooter.jsx